<template>
  <extend-modal :loading="state.loading" :toggle="closeModal" classes="content">
  <div class="create-subaccount">
    <div class="create-subaccount__content">
      <div class="flex-center">
      </div>
      <h1>Create Subaccount</h1>

      <p class="center">
        Enter a bank account number that matches with a bank name and you’re on
        your way to creating your subaccount
      </p>
      <form v-on:submit.prevent="handleSubmit" action="">
        <InputV2
          placeholder="Enter NUBAN"
          type="text"
          :required="true"
          v-model="state.nuban"
          :value="state.nuban"
          :disabled="false"
          :showInput="true"
          :maxlength="10"
          oninvalid="setCustomValidity('Account number must be 10 digits.')"
        />
        <SelectSearch
          :options="
            bankList.map(({ code, name }) => ({ value: code, text: name }))
          "
          :onOptionSelected="(value) => handleBankSelected(value)"
          placeholder="Select Bank"
        />
        <Dropdown
          v-if="state.isVerified"
          title="Account Name"
          :label="state.accountName"
          :disabled="true"
        />
        <Button
          :buttonName="state.buttonName"
          classes="woven-color"
          buttonType="submit"
          :disabled="state.disabled"
        />
      </form>
    </div>
  </div>
  </extend-modal>
</template>
<script type="text/javascript">
import Vue from "vue";
import { computed, onMounted, reactive, watch } from "@vue/composition-api";
import WovenStrip from "@/components/wovenstrip.vue";
import InputV2 from "@/components/inputv2.vue";
import Button from "@/components/button.vue";
import Dropdown from "@/components/dropdown.vue";
import SelectSearch from "@/components/selectsearch.vue";
import ExtendModal from "@/components/ExtendModal.vue";

export default {
  name: "CreateModal",
  props: {
    closeModal: {
      type: Function,
      default: () => {},
    },
	fetchSubaccounts: {
      type: Function,
      default: () => {},
    },
  },
  setup(props, { root, emit }) {
    const store = root.$store;

    const state = reactive({
      nuban: "",
      bank: "",
      bankCode: "",
      disabled: true,
      isVerified: false,
      accountName: "",
      buttonName: "Verify Account",
      loading: false,
    });

    watch([() => state.bankCode, () => state.nuban], () => {
      if (state.nuban.length === 10 && state.bankCode.length) {
        state.disabled = false;
      } else {
        state.disabled = true;
      }
    });

    const bankList = computed(() => store.getters.getBankList);

    const handleBankSelected = ({ text, value }) => {
      state.bank = text;
      state.bankCode = value;
    };

    const handleSubmit = async () => {
      try {
        state.loading = true;

        if (state.buttonName === "Verify Account") {
          const bankDetails = await Vue.http.post("dashboard/nuban/enquiry", {
            nuban: state.nuban,
            bank_code: state.bankCode,
          });

          state.loading = false;
          state.disabled = false;

          state.accountName = bankDetails.body.data.account_name;
          state.isVerified = true;
          state.buttonName = "Create Subaccount";
        } else {
          // create sub account
          await Vue.http.post("v2/dashboard/accounts/create", {
            nuban: state.nuban,
            bank_code: state.bankCode,
            account_name: state.accountName,
          });

          props.closeModal();

          state.loading = false;
          state.disabled = false;
          state.bank = "";
          state.bankCode = "";
          state.isVerified = false;

          Vue.notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: "subaccount added successfully",
          });
          props.fetchSubaccounts()
        }
      } catch (err) {
        state.loading = false;
        state.disabled = false;
        state.bank = "";
        state.nuban = "";
        state.bankCode = "";
        state.isVerified = false;
        state.buttonName = "Verify Account";
        state.accountName = "";

        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: err.message || err.body.message,
        });
      }
    };
    return {
      state,
      bankList,
      handleBankSelected,
      handleSubmit,
    };
  },
  components: {
    InputV2,
    Button,
    Dropdown,
    WovenStrip,
    SelectSearch,ExtendModal
  },
};
</script>
<style lang="scss">

  .content {
    width: 600px !important;
  }
.create-subaccount {
  padding: 40px;
  position: relative;
  max-width: 80%;
  margin: 0 auto;

  &__content {
    width: 404px;
  }

  .woven-strip {
    position: absolute;
    left: 0;
  }

  .center {
    text-align: center;
  }

  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .input-v2 {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  .drop-down-component {
    margin-bottom: 32px;
  }

  svg {
    height: 64px;
    width: 56px;
  }

  h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 36px;
    color: #000000;
    text-align: center;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #616e7c;
  }

  .drop-down {
    width: 100%;
  }

  .btn {
    width: 100%;
  }
}
</style>